import Video from '../assets/video/tesla_video.webm';
import Video2 from '../assets/video/AdobeStock_312841959_Video_HD_Preview.webm';
import Video3 from '../assets/video/AdobeStock_358892627_Video_HD_Preview.webm';
export var HeroData = function (video) { return ({
    heroHeadline: {
        title: 'Envestnet is Fully Vested™ in connecting people’s daily financial lives with their long-term goals',
        showArrowIcon: true,
        stats: '65%',
    },
    heroVideoCarousel: {
        video: {
            id: 'video-background',
            src: video.src,
            poster: '../assets/images/hero/video_still.png',
            videoType: 'video/webm',
        },
        card: {
            slides: [
                {
                    slidePosition: 0,
                    classes: 'first-slide',
                    subTitle: {
                        content: 'Your',
                        variant: 'h1',
                        classes: 'your',
                    },
                    title: {
                        content: 'Financial Intel',
                        variant: 'h1',
                        classes: 'financial',
                    },
                    subTitle2: {
                        content: '16 May 2022',
                        variant: 'h1',
                        classes: 'date',
                    },
                    showIntelline: true,
                    subText: {
                        content: 'Is this the most common stock concentration?',
                        variant: 'h1',
                        classes: 'subtext',
                    },
                    showLoadingIcon: false,
                    ctaLink: {
                        href: '',
                        text: '',
                        classes: '',
                    },
                },
                {
                    slidePosition: 1,
                    classes: 'second-slide',
                    subTitle: {
                        content: '',
                        variant: 'h1',
                        classes: '',
                    },
                    title: {
                        content: '65% of portfolios have a stock concentration in Tesla Motors.',
                        variant: 'h3',
                        classes: 'text',
                    },
                    subTitle2: {
                        content: '',
                        variant: '',
                        classes: '',
                    },
                    showIntelline: false,
                    subText: {
                        content: 'TSLA $1,054.73',
                        variant: 'h3',
                        classes: 'subtext',
                    },
                    showLoadingIcon: true,
                    ctaLink: {
                        href: '',
                        text: '',
                        classes: '',
                    },
                },
                {
                    slidePosition: 2,
                    classes: 'third-slide',
                    subTitle: {
                        content: '',
                        variant: 'h1',
                        classes: '',
                    },
                    title: {
                        content: '',
                        variant: 'h1',
                        classes: '',
                    },
                    subTitle2: {
                        content: '',
                        variant: '',
                        classes: '',
                    },
                    showIntelline: false,
                    subText: {
                        content: 'Are you quantifying risk for your clients so their financial plan never ends up in Ludicrous mode?',
                        variant: 'h3',
                        classes: 'subtext',
                    },
                    showLoadingIcon: false,
                    ctaLink: {
                        href: 'https://envestnet-storybook.netlify.app/?path=/story/components-modules-intelligentlife--default',
                        text: 'Learn more',
                        classes: '',
                    },
                },
            ],
        },
    },
}); };
export var SampleStoryCarouselData = {
    title: 'Envestnet is Fully Vested\u2122 in connecting people\u2019s daily lives with their long-term goals',
    showArrowIcon: true,
    stories: [
        {
            heroHeadline: { stats: '40%' },
            heroVideoCarousel: {
                video: {
                    id: 'video-background',
                    src: Video,
                    poster: '/sites/default/files/2022-07/HeroVideo1-Still.png',
                    videoType: 'video/mp4',
                },
                card: {
                    defaultState: {
                        subTitle: { content: 'Your', variant: 'h1', classes: 'your' },
                        title: {
                            content: 'Financial Intel',
                            variant: 'h1',
                            classes: 'financial',
                        },
                        subTitle2: {
                            content: '31 Aug 2022',
                            variant: 'h1',
                            classes: 'date',
                        },
                        showIntelline: true,
                        subText: {
                            content: 'What if cab rides could turn into crypto?',
                            variant: 'h3',
                            classes: 'subtext',
                        },
                    },
                    slides: [
                        {
                            slidePosition: 1,
                            classes: 'second-slide',
                            subTitle: { content: '', variant: 'h1', classes: '' },
                            title: {
                                content: 'Imagine parlaying a friend\u2019s ride repayment into a crypto purchase\u2014natively in PayPal.',
                                variant: 'h3',
                                classes: 'text',
                            },
                            subTitle2: { content: '', variant: '', classes: '' },
                            showIntelline: false,
                            subText: {
                                content: 'Are you ready for this new generation of investors?',
                                variant: 'h3',
                                classes: 'subtext',
                            },
                            imageUrl: '',
                            imageAlt: null,
                            showStats: false,
                            ctaLink: {
                                href: '/financial-intel/a-new-category-of-financial-services-embedded-finance',
                                text: 'Learn More',
                                target: '',
                                classes: 'secondary-btn',
                            },
                        },
                    ],
                },
            },
        },
        {
            heroHeadline: { stats: '40%' },
            heroVideoCarousel: {
                video: {
                    id: 'video-background',
                    src: Video2,
                    poster: '/sites/default/files/2022-07/HeroVideo2-Still.png',
                    videoType: 'video/mp4',
                },
                card: {
                    defaultState: {
                        subTitle: { content: 'Your', variant: 'h1', classes: 'your' },
                        title: {
                            content: 'Financial Intel',
                            variant: 'h1',
                            classes: 'financial',
                        },
                        subTitle2: {
                            content: '31 Aug 2022',
                            variant: 'h1',
                            classes: 'date',
                        },
                        showIntelline: true,
                        subText: {
                            content: 'Less is more. Until it comes to client communication.',
                            variant: 'h3',
                            classes: 'subtext',
                        },
                    },
                    slides: [
                        {
                            slidePosition: 1,
                            classes: 'second-slide',
                            subTitle: { content: '', variant: 'h1', classes: '' },
                            title: {
                                content: 'Less than 40% of clients feel their advisors contact them enough to discuss life changes that affect their plans.',
                                variant: 'h3',
                                classes: 'text',
                            },
                            subTitle2: { content: '', variant: '', classes: '' },
                            showIntelline: false,
                            subText: {
                                content: 'It\u2019s time to change your engagement strategy',
                                variant: 'h3',
                                classes: 'subtext',
                            },
                            imageUrl: '',
                            imageAlt: null,
                            showStats: true,
                            ctaLink: {
                                href: '/financial-intel/data-driven-recommendations-with-insights-engine',
                                text: 'Learn More',
                                target: '',
                                classes: 'secondary-btn',
                            },
                        },
                    ],
                },
            },
        },
        {
            heroHeadline: { stats: '40%' },
            heroVideoCarousel: {
                video: {
                    id: 'video-background',
                    src: Video3,
                    poster: '/sites/default/files/2022-07/Still_image_mrKrabs.png',
                    videoType: 'video/mp4',
                },
                card: {
                    defaultState: {
                        subTitle: { content: 'Your ', variant: 'h1', classes: 'your' },
                        title: {
                            content: 'Financial Intel',
                            variant: 'h1',
                            classes: 'financial',
                        },
                        subTitle2: {
                            content: '31 Aug 2022',
                            variant: 'h1',
                            classes: 'date',
                        },
                        showIntelline: true,
                        subText: {
                            content: 'Ever feel like you\u2019re lost at sea when managing a client\u2019s complex finances?',
                            variant: 'h3',
                            classes: 'subtext',
                        },
                    },
                    slides: [
                        {
                            slidePosition: 1,
                            classes: 'second-slide',
                            subTitle: { content: '', variant: 'h1', classes: '' },
                            title: {
                                content: 'Envestnet\u2019s customized dashboard shows their complete financial picture, all in one place.',
                                variant: 'h3',
                                classes: 'text',
                            },
                            subTitle2: { content: '', variant: '', classes: '' },
                            showIntelline: false,
                            subText: {
                                content: 'So you can help the trickiest of clients lead an Intelligent Financial Life\u2122. Even Mr. Krabs.',
                                variant: 'h3',
                                classes: 'subtext',
                            },
                            imageUrl: '',
                            imageAlt: null,
                            showStats: false,
                            ctaLink: {
                                href: '/intelligent-financial-life',
                                text: 'Learn More',
                                target: '',
                                classes: 'secondary-btn',
                            },
                        },
                    ],
                },
            },
        },
    ],
};
